// extracted by mini-css-extract-plugin
module.exports = {"container":"_024c5__index-module__container","titleRow":"d328d__index-module__title-row"};